import { t } from 'ember-intl';
import TioLoadingSpinner from 'tio-common/components/tio/loading-spinner';

<template>
  <div class="tio-col-flush h-screen container mx-auto">
    <h2 class="mt-6 text-center text-lg">{{t "login.in_progress"}}</h2>

    <div class="tio-row-flush grow">
      <TioLoadingSpinner />
    </div>
  </div>
</template>
